import * as z from "zod";

export const getGiftReceiptRequestsCount = {
  name: "getGiftReceiptRequestsCount" as const,
  input: z.object({}),
  output: z.object({ total: z.number() }),
};
